export const general = {
  company: "Εταιρεία",
  login: "Σύνδεση",
  logout: "Αποσύνδεση",
  signUp: "Εγγραφή",
  createAccount: "Δημιουργία λογαριασμού",
  username: "Όνομα χρήστη",
  usernameOrEmail: "Όνομα χρήστη ή email",
  password: "Κωδικός",
  confirmPassword: "Επιβεβαίωση κωδικού",
  authSignInTitle: "Σύνδεση",
  authRegisterTitle: "Δημιουργία λογαριασμού",
  authSignInLead: "Χρησιμοποιήστε τον λογαριασμό σας για να συνεχίσετε.",
  authRegisterLead: "Επιλέξτε πώς θα χρησιμοποιείτε την αγορά και δημιουργήστε λογαριασμό.",
  authHaveAccount: "Έχετε ήδη λογαριασμό;",
  authNeedAccount: "Νέος στην αγορά;",
  continueWithGitHub: "Συνέχεια με GitHub",
  authRolePrompt: "Συμμετέχω ως",
  authRoleBuyerHint: "Βρίσκω και ζητώ προϊόντα και υπηρεσίες.",
  authRoleSellerHint: "Καταχωρώ προϊόντα και λαμβάνω αιτήματα.",
  authRoleHybridHint: "Αγοράζω και πουλώ με τον ίδιο λογαριασμό.",
  authInvalidEmail: "Εισάγετε έγκυρο email",
  authPasswordMin: "Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες",
  authPasswordsMismatch: "Οι κωδικοί δεν ταιριάζουν",
  authGenericError: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
  finishingAccount: "Ολοκλήρωση λογαριασμού",
  completeRegistrationRetry: "Δοκιμάστε ξανά",
  completeRegistrationSignedOut: "Συνδεθείτε για να ολοκληρώσετε τον λογαριασμό σας.",
  profile: "Προφίλ",
  profileGreeting: "Γεια σου {{name}}",
  profileGreetingGeneric: "Γεια σου",
  language: "Γλώσσα",
  search: "Αναζήτηση",
  cancel: "Ακύρωση",
  cancelEoi: "Ακύρωση EoI",
  cancelEoiConfirm: "Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτό το EoI;",
  cancelEoiSuccess: "Η έκφραση ενδιαφέροντος ακυρώθηκε.",
  cancelEoiError: "Δεν ήταν δυνατή η ακύρωση της έκφρασης ενδιαφέροντος.",
  removeCancelledEoi: "Αφαίρεση από τη λίστα",
  removeCancelledEoiConfirm:
    "Να αφαιρεθεί αυτό το ακυρωμένο αίτημα από τη λίστα σας;",
  removeCancelledEoiHint:
    "Θα εξαφανιστεί από τις Αιτήσεις μου για εσάς. Το άλλο μέρος μπορεί να το αφαιρέσει ξεχωριστά.",
  removeCancelledEoiSuccess: "Το ακυρωμένο αίτημα αφαιρέθηκε από τη λίστα σας.",
  removeCancelledEoiError: "Δεν ήταν δυνατή η αφαίρεση του ακυρωμένου αιτήματος.",
  cancelledEoiBanner:
    "Η έκφραση ενδιαφέροντος ακυρώθηκε και δεν είναι πλέον ενεργή.",
  orderViewProduct: "Προβολή προϊόντος",
  orderViewProductPassport: "Άνοιγμα DPP",
  add: "Προσθήκη",
  firstName: "Όνομα",
  lastName: "Επώνυμο",
  email: "Email",
  role: "Ρόλος",
  image: "Εικόνα",
  application: "Εφαρμογή",
  valid: "Έγκυρο",
  required: "Υποχρεωτικό",
  address: "Διεύθυνση",
  city: "Πόλη",
  postalCode: "Ταχυδρομικός Κώδικας",
  country: "Χώρα",
  phone: "Τηλέφωνο",
  logo: "Λογότυπο",
  backOffice: "Back Office",
  home: "Αρχική",
  homePage: "Αρχική Σελίδα",
  ourPartners: "Οι Συνεργάτες μας",
  suppliers: "Προμηθευτές",
  customers: "Πελάτες",
  partners: "Συνεργάτες",
  workWithUs: "Συνεργαστείτε μαζί μας",
  uploadFile: "Ανέβασμα Αρχείου",
  uploadImage: "Ανέβασμα Εικόνας",
  uploadDocument: "Ανέβασμα Εγγράφου",
  setToDefaultImage: "Ορισμός σε προεπιλεγμένη εικόνα",
  upload: "Ανέβασμα",
  uploadImages: "Ανέβασμα Εικόνων",
  uploadDocuments: "Ανέβασμα Εγγράφων",
  noImages: "Χωρίς εικόνες",
  noDocuments: "Χωρίς έγγραφα",
  cart: "Καλάθι",
  yes: "Ναι",
  no: "Όχι",
  myOrders: "Οι Παραγγελίες μου",
  deleteImage: "Διαγραφή Εικόνας",
  undoDeleteImage: "Αναίρεση Διαγραφής Εικόνας",
  orders: "Παραγγελίες",
  account: "Λογαριασμός",
  reset: "Επαναφορά",
  apply: "Εφαρμογή",
  openInDesktop: "Παρακαλώ ανοίξτε από υπολογιστή",
  mainAppLogo: "Κύριο Λογότυπο Εφαρμογής",
  footerLogo: "Λογότυπο Υποσέλιδου",
  appName: "Όνομα Εφαρμογής",
  projectName: "Όνομα Έργου",
  appConfig: "Διαμόρφωση Εφαρμογής",
  dataStructures: "Δομές Δεδομένων",
  appLogoAltText: "Εναλλακτικό Κείμενο Λογοτύπου Εφαρμογής",
  appFooterLogoAltText: "Εναλλακτικό Κείμενο Λογοτύπου Υποσέλιδου",
  footerEuFlagImage: "Εικόνα Ευρωπαϊκής Σημαίας Υποσέλιδου",
  footerEuFlagImageAltText:
    "Εναλλακτικό Κείμενο Εικόνας Ευρωπαϊκής Σημαίας Υποσέλιδου",
  fundedBy:
    "Αυτό το έργο έχει λάβει χρηματοδότηση από το πρόγραμμα Horizon Europe της Ευρωπαϊκής Ένωσης στο πλαίσιο της συμφωνίας επιχορήγησης αριθ.",
  projectRegistrationNumber: "Αριθμός Εγγραφής Έργου",
  footerCentralImageContent: "Περιεχόμενο Κεντρικής Εικόνας Υποσέλιδου",
  basicData: "Βασικά Δεδομένα",
  footerData: "Δεδομένα Υποσέλιδου",
  socialMedia: "Κοινωνικά Δίκτυα",
  footerCentralImageSrc: "Πηγή Κεντρικής Εικόνας Υποσέλιδου",
  hasCart: "Διαθέτει Καλάθι",
  hasMultiLanguage: "Διαθέτει Πολλαπλές Γλώσσες",
  basicInfo: "Βασικές Πληροφορίες",
  companyName: "Όνομα Εταιρείας",
  edit: "Επεξεργασία",
  tabTitle: "Τίτλος Καρτέλας",
  favicon: "Εικονίδιο Καρτέλας (μέγεθος: 64x64)",
  userRole: "Ρόλος Χρήστη",
  userRoles: "Ρόλοι Χρήστη",
  buyer: "Αγοραστής",
  seller: "Πωλητής",
  hybrid: "Υβριδικός",
  myRequests: "Οι Αιτήσεις μου",
  myRequestsUnreadAria: "Οι Αιτήσεις μου, νέα εισερχόμενα αιτήματα",
  orderNewBadge: "ΝΕΟ",
  myRequestsNoActivity: "Δεν υπάρχει δραστηριότητα προς εμφάνιση",
  myRequestsNoActivityHint:
    "Όταν υποβάλετε παραγγελία, εκφράσετε ενδιαφέρον ή λάβετε παραγγελία για τις καταχωρήσεις σας, θα εμφανίζεται εδώ.",
  myRequestsMyOrdersError: "Δεν ήταν δυνατή η φόρτωση των Παραγγελιών μου.",
  myRequestsReceivedOrdersError:
    "Δεν ήταν δυνατή η φόρτωση των Παραγγελιών που ελήφθησαν.",
  createRequest: "Δημιουργία Αίτησης",
  sortBy: "Ταξινόμηση",
  priceAscending: "Τιμή Αύξουσα",
  priceDescending: "Τιμή Φθίνουσα",
  resetSorting: "Επαναφορά Ταξινόμησης",
  landingPageBackgroundImageSrc:
    "Πηγή Εικόνας Φόντου Αρχικής Σελίδας (Ελάχιστο πλάτος: 1920)",
  basicConfiguration: "Βασικές Ρυθμίσεις",
  syncWithSurplex: "Συγχρονισμός με Surplex",
  sync: "Συγχρονισμός",
  created: "Δημιουργήθηκε",
  updated: "Ενημερώθηκε",
  submitted: "Υποβλήθηκε",
  active: "Ενεργό",
  userActions: "Ενέργειες Χρήστη",
  uploadFiles: "Ανέβασμα Αρχείων",
  saveAndClose: "Αποθήκευση και Κλείσιμο",
  saveAndContinue: "Αποθήκευση και Συνέχεια",
  exit: "Exit",
  continue: "Συνέχεια",
  closeAndContinue: "Κλείσιμο και Συνέχεια",
  unableToInitializeKeycloak: "Αδυναμία Αρχικοποίησης Keycloak",
  logs: "Καταγραφές",
  getProducts: "Λήψη Προϊόντων",
  deleteProducts: "Διαγραφή Προϊόντων",
  images: "Εικόνες",
  about: "Σχετικά",
  aboutPage: "Σελίδα Σχετικά",
  aboutImage: "Εικόνα Σxετικά",
  policyFiles: "Αρχεία Πολιτικής",
  projectLink: "Σύνδεσμος Έργου",
  visitProject: "Επίσκεψη Έργου",
  categories: "Κατηγορίες",
  menu: "Μενού",
  homePageUrl: "Homepage Url",
  saving: "Αποθήκευση",
  loading: "Φόρτωση",
  syncedWith: "Συγχρονίστηκε με",
  errorSyncingWith: "Σφάλμα συγχρονισμού με",
  deletedProducts: "Διαγραφή προϊόντων",
  errorDeletingProducts: "Σφάλμα διαγραφής προϊόντων",
  deleted: "Διαγράφηκε",
  error: "Σφάλμα",
  added: "Προστέθηκαν",
  duration: "Διάρκεια",
  fetched: "Λήφθησαν",
  thisPropertyWillBeDeleted: "Αυτή η ιδιότητα θα διαγραφεί",
  propertyName: "Όνομα Ιδιότητας",
  mainButtonColor: "Χρώμα κύριου κουμπιού",
  mainButtonTextColor: "Χρώμα κειμένου κύριου κουμπιού",
  mainButtonHoverColor: "Χρώμα κύριου κουμπιού όταν περνάει ο δείκτης",
  mainButtonHoverTextColor:
    "Χρώμα κειμένου κύριου κουμπιού όταν περνάει ο δείκτης",
  navbarBackgroundColor: "Χρώμα φόντου γραμμής πλοήγησης",
  navbarTextColor: "Χρώμα κειμένου γραμμής πλοήγησης",
  pageNotFound: "Η σελίδα δεν βρέθηκε",
  goToHome: "Επιστροφή στην αρχική σελίδα",
  back: "Πίσω",
  save: "Αποθήκευση",
  submit: "Υποβολή",
  expand: "Ανάπτυξη",
  collapse: "Σύμπτυξη",
  fileAlreadyListed: "Το {{name}} είναι ήδη στη λίστα.",
  removeFile: "Αφαίρεση αρχείου",
  jsonBeautify: "Μορφοποίηση JSON",
  jsonInvalid: "Εισαγάγετε έγκυρο JSON.",
  jsonPayloadLabel: "Φορτίο JSON",
  jsonEditorPlaceholder: '{ "key": "value" }',
  jsonEditorHint:
    "Επικολλήστε ή επεξεργαστείτε JSON. Χρησιμοποιήστε τη μορφοποίηση για εσοχές.",
};
